import '../../styles/Busquedas/busquedasBanner.scss';

export const BusquedaBanner = () => {
  return (
<div className='busquedas-banner'>
    <div className='banner-container'>
        <div className='banner'>
            <div className='banner-content'>
                <h3 data-aos="fade-up" data-aos-delay="200" data-aos-duration="800" data-aos-easing="ease-out">
                    Encontrá el lugar perfecto para tu talento
                </h3>
                <p data-aos="fade-up" data-aos-delay="400" data-aos-duration="800" data-aos-easing="ease-out">
                    Nos especializamos en búsqueda y selección de perfiles IT para LATAM y logramos captar a los mejores talentos porque conocemos la dinámica del mercado, trabajamos codo a codo con nuestros clientes para determinar las necesidades y así poder generar la propuesta de valor más atractiva.
                </p>
                <a data-aos="fade-up" data-aos-delay="600" data-aos-duration="800" data-aos-easing="ease-out" href="https://www.halaxia.com/empresa/serendipia-consultora" className='button' target='_blank' rel='noreferrer'>
                    Cargá tu cv
                </a>
            </div>
            <div data-aos="zoom-in" data-aos-delay="500" data-aos-duration="1000" data-aos-easing="ease-out" className='background-banner'></div>
        </div>
    </div>
</div>

  );
};
